import React, { useState } from 'react';
import { Box, Typography, Grid, Button, Divider, Chip, IconButton, Drawer, List, ListItem } from '@mui/material';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useMediaQuery } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';

import Lidya from '../Assets/lidya.jpg';
import Kidus from '../Assets/kidus4.jpg';
import Beza from '../Assets/BezaMuluneh.jpg';
import hansa from '../Assets/hana.jpg';
import Senay from '../Assets/senay.jpg';
import Abel from '../Assets/abel2.jpg';
import Elias from '../Assets/elias2.jpg';
import Abreham from '../Assets/AbrehamTsegaye.jpg';
import Seolome from '../Assets/SelomeHaddis.JPG';

import Nardos from '../Assets/nardi.jpg';
// Container animation for staggering children
const containerVariant = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

// Card animation for bottom-to-top effect
const cardVariant = {
  hidden: {
    opacity: 0,
    y: 80,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: [0.4, 0, 0.2, 1],
      type: 'spring',
      stiffness: 80,
      damping: 20,
    },
  },
};

const TeamSection = React.forwardRef((props, ref) => {
  const teamMembers = [
    { id: 1, name: 'Senay Amdework', role: 'CEO', image: Senay, linkedin: 'https://www.linkedin.com/in/senay-fenta-33a49a129', department: ['Leadership'] },
    { id: 2, name: 'Nardos Amdework', role: 'COO', image: Nardos, linkedin: 'https://www.linkedin.com/in/nardos-amdework', department: ['Leadership'] },
    { id: 3, name: 'Abreham Tsegaye', role: 'Finance Manager', image: Abreham, linkedin: 'https://www.linkedin.com/in/abreham-tsegaye-745b16340/', department: ['Finance', 'Leadership'] },
    // { id: 9, name: 'Selome Haddis', role: 'Marketing and Social Media Manager ', image: Seolome, linkedin: 'https://www.linkedin.com/in/selome-haddis-393920367/', department: ['Marketing', 'Leadership'] },
    { id: 8, name: 'Bezawit Muluneh', role: 'HR Officer', image: Beza, linkedin: '', department: ['HR', 'Leadership'] },
    // { id: 4, name: 'Kidus Alemayehu', role: 'Team Lead Backend Developer', image: Kidus, linkedin: 'https://www.linkedin.com/in/kidus-alemayehu-7533b7190' , department: ['Engineering']},
    { id: 5, name: 'Lidya Dagnew', role: 'Team Lead Frontend Developer', image: Lidya, linkedin: 'https://www.linkedin.com/in/lidya-dagnew-aa4136236', department: ['Engineering'] },
    // { id: 6, name: 'Abel Teha', role: 'Team Lead Frontend Developer', image: Abel, linkedin: 'https://www.linkedin.com/in/abel-teha-62337b23b' , department: ['Engineering']},
    // { id: 7, name: 'Elias Nurhussien', role: 'Team Lead Mobile Developer', image: Elias, linkedin: 'https://www.linkedin.com/in/elias-nurhussien' , department: ['Engineering']},  




  ];
  const [showAll, setShowAll] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const filteredMembers = selectedCategory === 'All'
    ? teamMembers
    : teamMembers.filter(member => member.department.includes(selectedCategory));
  const visibleMembers = showAll ? filteredMembers : filteredMembers.slice(0, 6);
  const categories = ['All', 'Leadership', 'Engineering', 'Finance', 'HR', 'Marketing'];
  const isMobile = useMediaQuery('(max-width:600px)');
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <SectionContainer ref={ref} component={motion.div} variants={containerVariant} initial="hidden" whileInView="visible" sx={{ mb: { xs: '14px', sm: '24px', md: '50px' } }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          fontSize: { xs: '18px', sm: '30px', md: '40px' },
          mb: { xs: "14px", sm: '24px', md: '30px' },
          color: '#1a1a1a',
          textAlign: 'center',
        }}
      >
        Meet Our Team
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: { xs: '10px', sm: '16px', md: '20px' },
          color: '#666666',
          textAlign: 'center',
          mb: { xs: "16px", sm: '24px', md: '30px' },
          mx: 'auto',
          width: { xs: '175px', sm: 'auto' }
        }}
      >
        passionate professionals deriving innovation forward
      </Typography>
      <Divider sx={{ mb: 6, width: { xs: '231px', md: '312px' }, mx: 'auto', borderColor: '#17273F', borderBottomWidth: '3px' }} />
      {isMobile ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mb: 3 }}>
          <Chip
            label={selectedCategory}
            sx={{ backgroundColor: '#17273F', color: '#fff', px: 2 }}
          />
          <IconButton onClick={() => setDrawerOpen(true)}>
            <TuneIcon sx={{ color: '#0a66c2' }} />
          </IconButton>

          <Drawer anchor="bottom" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2, m: 2 }} >
              {categories.map(category => (
                <Chip
                  key={category}
                  label={category}
                  onClick={() => setSelectedCategory(category)}
                  sx={{
                    backgroundColor: selectedCategory === category ? '#17273F' : '#f0f4ff',
                    color: selectedCategory === category ? '#fff' : '#0a66c2',
                    fontSize: "14px",
                    fontWeight: 500,
                    px: 2,
                    py: 1,
                    borderRadius: '20px',
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: selectedCategory === category ? '#004182' : '#e6f0ff' },
                  }}
                />
              ))}
            </Box>
          </Drawer>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2, mb: 12 }} >
          {categories.map(category => (
            <Chip
              key={category}
              label={category}
              onClick={() => setSelectedCategory(category)}
              sx={{
                backgroundColor: selectedCategory === category ? '#17273F' : '#EDF1FF',
                color: selectedCategory === category ? '#fff' : '#3366FF',
                fontSize: "14px",
                fontWeight: 500,
                px: 2,
                py: 1,
                borderRadius: '20px',
                cursor: 'pointer',
                '&:hover': { backgroundColor: selectedCategory === category ? '#004182' : '#e6f0ff' },
              }}
            />
          ))}
        </Box>)}
      <Grid container spacing={{ xs: 1, sm: 4, md: 3, lg: 8 }} >
        {visibleMembers.map((member) => (
          <Grid item xs={4} sm={6} md={4} key={member.id} component={motion.div}
            variants={cardVariant}
            initial="hidden"
            animate="visible"
            exit="hidden"
            layout
            sx={{ mb: { xs: 1, sm: 3 } }}>
            <MotionCard
              variants={cardVariant}
              whileHover={{
                scale: 1.05,
                boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                transition: { duration: 0.4 },
              }}
              sx={{ p: { xs: '4px', sm: '12px', md: '16px', lg: '20px' } }}
            >
              <ImageWrapper>
                <Image src={member.image} alt={member.name} />
              </ImageWrapper>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mt: { xs: 1, md: 2 } }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                  <Typography sx={{ fontWeight: 700, color: '#000000', textAlign: 'left', fontSize: { xs: '8px', sm: '14px', md: '20px', lg: '20px' } }}>
                    {member.name}
                  </Typography>
                  <Typography sx={{ color: '#ddd', fontWeight: 400, fontSize: "14px", textAlign: 'left', color: "#000000", fontSize: { xs: '8px', sm: '14px', md: '17px', lg: '17px' } }}>
                    {member.role}
                  </Typography>
                </Box>

                <LinkedInLink href={member.linkedin} target="_blank" rel="noopener noreferrer">
                  <LinkedInIcon sx={{ color: '#0a66c2', fontSize: { xs: '10px', sm: '18px', md: '22px', lg: '28px' }, mt: 1, '&:hover': { color: '#0a66c2' } }} />
                </LinkedInLink>
              </Box>
            </MotionCard>
          </Grid>
        ))}
      </Grid>
      {visibleMembers.length === 0 && (
        <Typography variant="body1" sx={{ color: '#999', mt: 4 }}>
          No team members found in this department.
        </Typography>
      )}
      {filteredMembers.length > 6 && (
        <Button
          variant="contained"
          sx={{ mt: { xs: 4, sm: 8 }, backgroundColor: '#17273F', color: '#fff', fontSize: '16px', '&:hover': { backgroundColor: '#004182' }, borderRadius: '10px', width: '145px' }}
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? 'View Less' : 'View More'}
        </Button>)}
    </SectionContainer>
  );
});


const SectionContainer = styled(Box)({
  width: "100%",
  maxWidth: "1400px",
  margin: "0 auto",
  padding: "10px 20px",
  textAlign: "center",

  "@media (max-width: 900px)": {
    padding: "10px 15px",
  },
  "@media (max-width: 600px)": {
    padding: "10px 8px",
  },
});


const ImageCard = styled(Box)({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  borderRadius: '16px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  backgroundColor: '#fff',
  '@media (max-width: 600px)': {
    borderRadius: "5px",
  },
});

const MotionCard = motion(ImageCard);

const ImageWrapper = styled(Box)({
  position: 'relative',
  width: '100%',
  aspectRatio: '3 / 4',
  overflow: 'hidden',
  borderRadius: '12px',
  backgroundColor: '#f9f9f9',
});

const Image = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'top center',
});




const TextOverlay = styled(Box)({
  position: 'absolute',
  bottom: 0,
  left: 0,
  padding: '20px',
  background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
  width: '100%',
  transition: 'background 0.3s ease',
});

const LinkedInLink = styled('a')({
  display: 'inline-block',
  textDecoration: 'none',
});

export default TeamSection;